'use client';

import { useContext } from 'react';
import { ProductSelectionContext } from '../contexts';

/**
 * Internal-only private hook holding the raw mutable data related to the
 * current product selection (option override, addons, quantity, etc).
 *
 * Do not import this in block components. This is far too much power for
 * components to have!!! We used to export this but that was a mistake as it
 * led to every little component deciding to manipulate product state.
 *
 * Instead, use public hooks from `components/product/product-context.js`
 * (`useSelectedVariant`, `useSelectionActions`, `useAdditionalProducts`, etc)
 * and let these handle this store for you.
 */
export function useSelectionStore() {
  const selectionStore = useContext(ProductSelectionContext);

  if (selectionStore === undefined) {
    throw new Error(
      'A product selection hook must be used within a ProductProvider'
    );
  }

  return selectionStore;
}
